import { Box } from '@mui/material';
import { ActivityHeaderSectionLayout } from 'modules/components/layer31';
import React, { ReactNode } from 'react';



export type ActivityHeaderSectionWithFIlterLayoutProps = {
  filterRow: ReactNode;
  title?: string;
  actionButtons?: ReactNode | ReactNode[];
  subtitle?: string;
  backButton?: ReactNode;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityHeaderSectionWithFIlterLayoutProps) => {
  return (
    <ActivityHeaderSectionLayout.FC
      title={props.title}
      subtitle={props.subtitle}
      actionButtons={props.actionButtons}
      backButton={props.backButton}
    >
      {/* FilterLogic Section */}
      <Box
        flex='1 1 0'
      >
        {props.filterRow}
      </Box>
    </ActivityHeaderSectionLayout.FC>
  );
};
